import axios from 'axios';

export default {
  get: (params) => axios.get('/api/v1/one/milestone-group', { params }),
  getById: (id) => axios.get(`/api/v1/one/milestone-group/${id}`),
  create: (params) => axios.post('/api/v1/one/milestone-group', params),
  update: (params) => axios.put(`/api/v1/one/milestone-group/${params.id}`, params),
  remove: (params) => axios.delete('/api/v1/one/milestone-group', { params }),
};
